import parse, { type DOMNode, type HTMLReactParserOptions } from 'html-react-parser';

const SAFE_URL_SCHEMES = new Set(['http:', 'https:', 'mailto:', 'tel:']);

function isSafeUrl(value: string): boolean {
  const trimmed = value.trim();
  if (trimmed === '' || trimmed.startsWith('/') || trimmed.startsWith('#')) return true;
  try {
    return SAFE_URL_SCHEMES.has(new URL(trimmed, 'https://sanitize.invalid').protocol);
  } catch {
    return false;
  }
}

function isElement(
  node: DOMNode,
): node is DOMNode & { name: string; attribs: Record<string, string> } {
  return 'attribs' in node;
}

function sanitizeNode(node: DOMNode) {
  if (!isElement(node)) return undefined;

  for (const attr of Object.keys(node.attribs)) {
    if (attr.toLowerCase().startsWith('on')) delete node.attribs[attr];
  }

  if (node.name === 'a' && node.attribs.href && !isSafeUrl(node.attribs.href)) {
    delete node.attribs.href;
  }

  if (node.name === 'img' && node.attribs.src && !isSafeUrl(node.attribs.src)) {
    delete node.attribs.src;
  }

  return undefined;
}

const options: HTMLReactParserOptions = { replace: sanitizeNode };

export function parseHtml(html: string) {
  return parse(html, options);
}
